import AppHeader from '../AppHeader'
export default {
  name: 'evaluate-question',
  components: {
    AppHeader
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question.js